var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoPinpointWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90761 5.82182C4.64442 6.49704 4.5 7.23165 4.5 8C4.5 12.5455 8.5 16.6364 10.5 18C11.3918 17.392 12.6812 16.2417 13.8364 14.7506L4.90761 5.82182ZM5.97453 4.06031L8.82339 6.90917C9.18023 6.36182 9.79786 6 10.5 6C11.6046 6 12.5 6.89543 12.5 8C12.5 8.70214 12.1382 9.31977 11.5908 9.67661L14.9792 13.065C15.8672 11.5439 16.5 9.8079 16.5 8C16.5 4.68629 13.8137 2 10.5 2C8.69407 2 7.07449 2.79786 5.97453 4.06031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4L16.5 17",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoPinpointWhite);
export default __webpack_public_path__ + "static/media/ic_no_pinpoint_white.cfac8f2dd27228bbc2f2c305c834e6b2.svg";
export { ForwardRef as ReactComponent };